<div fxFlexFill fxLayoutAlign="center center">
    <p [ngClass]="{'success': messageType == 'success', 'warn': messageType == 'warn', 'info': messageType == 'info'}" class="messageComponent">{{messageText}}</p>


</div>